// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__2Pf8z","tooltip":"Tooltip_tooltip__3CTll","visible":"Tooltip_visible__28s0i"};